import { AvailabilityStatus } from '@levelworks/shared-domain-types';
import {
  FlexWorkersForProjectFilterOptions,
  FlexWorkersForProjectFilterOptionsStrings,
  FlexWorkersForShiftFilterOptions,
  FlexWorkersForShiftFiltersStrings,
  MaxDistance,
} from '../flex-workers-for-work.types';

const stringFilterToBoolean = (value: string | undefined) => {
  switch (value) {
    case '1':
      return true;
    case '0':
      return false;
    default:
      return undefined;
  }
};

const booleanFilterToString = (value: boolean | undefined) => {
  switch (value) {
    case true:
      return '1';
    case false:
      return '0';
    default:
      return undefined;
  }
};

const stringToAvailabilityStatus = (value: string | undefined): AvailabilityStatus | undefined => {
  if (value === AvailabilityStatus.AvailableWithSchedule) {
    return AvailabilityStatus.AvailableWithSchedule;
  }
  if (value === AvailabilityStatus.AvailableOrConditional) {
    return AvailabilityStatus.AvailableOrConditional;
  }
  return undefined;
};

// TODO this can definitely be refactored

export const parseFlexWorkersForShiftFilters = (props: FlexWorkersForShiftFiltersStrings) => {
  const res: FlexWorkersForShiftFilterOptions = {};
  res.flexPoolOnly = stringFilterToBoolean(props.flexPoolOnly);
  res.maxDistance =
    props.maxDistance !== undefined && Number(props.maxDistance) !== 0
      ? (Number(props.maxDistance) as MaxDistance)
      : undefined;
  res.isAvailable = stringFilterToBoolean(props.isAvailable);
  res.workedForDepartment = stringFilterToBoolean(props.workedForDepartment);
  res.hasCertificate = stringFilterToBoolean(props.hasCertificate);
  res.availabilityStatus = stringToAvailabilityStatus(props.availabilityStatus);
  res.isFreelancer = stringFilterToBoolean(props.isFreelancer);
  res.isTempWorker = stringFilterToBoolean(props.isTempWorker);
  res.isEmployee = stringFilterToBoolean(props.isEmployee);

  return res;
};

export const stringifyFlexWorkersForShifts = (props: FlexWorkersForShiftFilterOptions) => {
  const res: FlexWorkersForShiftFiltersStrings = {};
  res.flexPoolOnly = booleanFilterToString(props.flexPoolOnly);
  res.maxDistance = props.maxDistance ? String(props.maxDistance) : undefined;
  res.isAvailable = booleanFilterToString(props.isAvailable);
  res.workedForDepartment = booleanFilterToString(props.workedForDepartment);
  res.hasCertificate = booleanFilterToString(props.hasCertificate);
  res.availabilityStatus = props.availabilityStatus;
  res.isFreelancer =
    typeof props.isFreelancer === 'boolean'
      ? booleanFilterToString(props.isFreelancer)
      : props.isFreelancer;
  res.isTempWorker =
    typeof props.isTempWorker === 'boolean'
      ? booleanFilterToString(props.isTempWorker)
      : props.isTempWorker;
  res.isEmployee =
    typeof props.isEmployee === 'boolean'
      ? booleanFilterToString(props.isEmployee)
      : props.isEmployee;

  return res;
};

export const ensureStringWorkerTypesForShifts = (props: FlexWorkersForShiftFiltersStrings) => {
  props.isFreelancer =
    typeof props.isFreelancer === 'boolean'
      ? booleanFilterToString(props.isFreelancer)
      : props.isFreelancer;
  props.isTempWorker =
    typeof props.isTempWorker === 'boolean'
      ? booleanFilterToString(props.isTempWorker)
      : props.isTempWorker;
  props.isEmployee =
    typeof props.isEmployee === 'boolean'
      ? booleanFilterToString(props.isEmployee)
      : props.isEmployee;

  return props;
};

export const stringifyFlexWorkersForProjectFilters = (
  props: FlexWorkersForProjectFilterOptions
) => {
  const res: FlexWorkersForProjectFilterOptionsStrings = {};
  res.flexPoolOnly = booleanFilterToString(props.flexPoolOnly);
  res.maxDistance = props.maxDistance ? String(props.maxDistance) : undefined;
  res.workedForDepartment = booleanFilterToString(props.workedForDepartment);
  res.hasCertificate = booleanFilterToString(props.hasCertificate);
  res.isFreelancer =
    typeof props.isFreelancer === 'boolean'
      ? booleanFilterToString(props.isFreelancer)
      : props.isFreelancer;
  res.isTempWorker =
    typeof props.isTempWorker === 'boolean'
      ? booleanFilterToString(props.isTempWorker)
      : props.isTempWorker;

  return res;
};

export const parseFlexWorkersForProjectFilters = (
  props: FlexWorkersForProjectFilterOptionsStrings
) => {
  const res: FlexWorkersForProjectFilterOptions = {};
  res.flexPoolOnly = stringFilterToBoolean(props.flexPoolOnly);
  res.maxDistance =
    props.maxDistance && props.maxDistance !== '0'
      ? (Number(props.maxDistance) as MaxDistance)
      : undefined;
  res.workedForDepartment = stringFilterToBoolean(props.workedForDepartment);
  res.hasCertificate = stringFilterToBoolean(props.hasCertificate);
  res.isFreelancer = stringFilterToBoolean(props.isFreelancer);
  res.isTempWorker = stringFilterToBoolean(props.isTempWorker);

  return res;
};

export const ensureStringWorkerTypesForProject = (
  props: FlexWorkersForProjectFilterOptionsStrings
) => {
  props.isFreelancer =
    typeof props.isFreelancer === 'boolean'
      ? booleanFilterToString(props.isFreelancer)
      : props.isFreelancer;
  props.isTempWorker =
    typeof props.isTempWorker === 'boolean'
      ? booleanFilterToString(props.isTempWorker)
      : props.isTempWorker;

  return props;
};
